import { make } from 'redux-chill';

const loading = make('[spinner] loading').stage('start').stage('finish');

export { loading };
